var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardAmount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 110,
    viewBox: "0 0 124 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_521)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_521",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 124,
    height: 110
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.38 0H0.5V109.07H123.38V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_521)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 55.7898H25.33V99.9698H0.5V55.7898ZM84.14 16.2398C85.52 13.1298 87.04 10.1798 88.87 7.68976C92.56 2.61976 101.59 -3.48024 107.11 2.42976C112.05 7.70976 107.86 13.4898 101.98 16.2398H115.3C116.33 16.2398 117.3 16.6698 117.96 17.3598C118.65 18.0498 119.08 18.9898 119.08 20.0198V27.1998C119.08 28.2298 118.65 29.1998 117.96 29.8598C117.34 30.4798 116.52 30.8898 115.6 30.9598V64.7498C122.6 65.3798 126.38 73.3398 120.47 79.1698C106.57 89.2798 92.32 97.5998 77.74 104.32C67.15 110.76 56.56 110.54 45.98 104.32L30.34 96.2598V59.3398H46.95C48.31 59.5798 49.67 59.9198 51.03 60.3398V30.9798C50.08 30.9198 49.23 30.5098 48.58 29.8798C47.89 29.1898 47.46 28.2498 47.46 27.2198V20.0398C47.46 19.0098 47.89 18.0398 48.58 17.3798C49.27 16.6898 50.21 16.2598 51.24 16.2598H64.8C58.94 13.5098 54.75 7.72976 59.67 2.44976C65.19 -3.48024 74.21 2.63976 77.91 7.70976C79.74 10.2198 81.26 13.1698 82.64 16.2598H84.12L84.14 16.2398ZM101.53 70.0598H84.74C87.78 72.0598 88.42 76.1098 84.18 79.0098C79.66 82.3298 73.69 82.1398 67.57 81.5898C63.35 81.3798 63.17 87.0498 67.57 87.0698C69.1 87.1898 70.76 86.8298 72.21 86.8298C79.85 86.8198 86.13 85.3598 89.98 79.3298L91.91 74.8198L101.53 70.0598ZM54.15 61.4498C57.73 62.8598 61.3 64.7598 64.88 66.8998H78.4V53.0798H54.15V61.4498ZM107.9 66.8998L111.11 65.3098C111.57 65.1598 112.03 65.0398 112.48 64.9398V53.0798H112.46H88.54V66.8998H107.9ZM96.19 16.2398C109.66 10.2698 105.19 0.209764 96.66 5.06976C94.66 6.20976 92.99 8.33976 91.48 10.4598C90.06 12.4598 88.79 14.5598 87.85 16.2398H96.19ZM70.58 16.2398C57.11 10.2698 61.58 0.209764 70.11 5.06976C72.11 6.20976 73.78 8.33976 75.29 10.4598C76.71 12.4598 77.98 14.5598 78.92 16.2398H70.58ZM54.15 44.6798H78.4V29.4698H54.15V44.6798ZM88.52 44.6798H112.43V29.4698H88.52V44.6798Z",
    fill: "#1e2a4a"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 110,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardAmount);
export default __webpack_public_path__ + "static/media/reward-amount.f70f638c12e5a64ec857db849d93cc95.svg";
export { ForwardRef as ReactComponent };